import { render } from "./AddUser.vue?vue&type=template&id=4be8ec0c&ts=true"
import script from "./AddUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddUser.vue?vue&type=script&setup=true&lang=ts"

import "./AddUser.vue?vue&type=style&index=0&id=4be8ec0c&lang=css"

import exportComponent from "/codebuild/output/src3693190966/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AddUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4be8ec0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4be8ec0c', __exports__)) {
    console.log('reload')
    api.reload('4be8ec0c', __exports__)
  }
  
  module.hot.accept("./AddUser.vue?vue&type=template&id=4be8ec0c&ts=true", () => {
    console.log('re-render')
    api.rerender('4be8ec0c', render)
  })

}


export default __exports__